import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import emailjs from 'emailjs-com'
import keys from '../assets/api-keys'

import '../css/Register.css'

import country_codes from './country_codes'

export default function Register() {
  const [name, set_name] = useState('')
  const [gender, set_gender] = useState('')
  const [birth_date, set_birth_date] = useState('')
  const [birth_month, set_birth_month] = useState('')
  const [birth_year, set_birth_year] = useState('')
  const [email, set_email] = useState('')
  const [phone, set_phone] = useState('+1')
  const [phone_country_code, set_phone_country_code] = useState('1')
  const [activity, set_activity] = useState('')
  const [other_activity, set_other_activity] = useState('')

  const [loading, set_loading] = useState(false)

  const [validate, set_validate] = useState({
    error: '',
    name: true,
    email: true,
    phone: true,
    activity: true,
    other_activity: true,
    birth_date: true,
    birth_month: true,
    birth_year: true
  })

  const loader = loading
               ? <div id="loader-container"><div id="loader">Loading...</div></div>
               : null

  const validate_error = validate.error !== ''
              ? <span>{validate.error}</span>
              : null

  const other = activity === 'Other'
              ? (
                   <input type="text"
                          placeholder="Other Activity"
                          className="text-input"
                          style={{
                            border: validate.other_activity ? '1px solid #f3f5f4' : '1px solid #dc3545',
                            backgroundColor: validate.other_activity ? '#f3f5f4' : 'white'
                          }}
                          onChange={ event => set_other_activity(event.target.value) }></input>
              ) : null

  return (
    <div id="register">
      <Helmet>
        <title>Register - Enoho Fikir</title>
      </Helmet>

      <div id="registration-form">
        <h1>Register a Volunteer</h1>

        <input type="text"
               placeholder="Full Name"
               className="text-input"
               value={name}
               onChange={ event => set_name(event.target.value) }
               style={{
                 border: validate.name ? '1px solid #f3f5f4' : '1px solid #dc3545',
                 backgroundColor: validate.name ? '#f3f5f4' : 'white'
               }}></input>

        <div className="select-box">
          <button className={ gender==='Male' ? 'active-select-option' : 'select-option' } onClick={ () => set_gender(gender==='Male' ? '' : 'Male') }>Male</button>
          <button className={ gender==='Female' ? 'active-select-option' : 'select-option' } onClick={ () => set_gender(gender==='Female' ? '' : 'Female') }>Female</button>
        </div>

        <div id="select-date">
          <select value={birth_month}
                  onChange={ event => set_birth_month(event.target.value) }
                  style={{
                    border: validate.birth_month ? '1px solid #f3f5f4' : '1px solid #dc3545'
                  }}>
            <option value="" selected disabled hidden>Month</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>

          <input type="text"
                 placeholder="Day"
                 value={birth_date}
                 onChange={ event => {
                  if (event.target.value.length > 2 ||
                     (event.target.value.length === 1 && parseInt(event.target.value) > 3) ||
                     (event.target.value.length === 2 && event.target.value.startsWith('3') &&
                     parseInt(event.target.value) > 31))
                    return
                  set_birth_date(event.target.value.replace(/\D/g,''))
                 }}
                 style={{
                   border: validate.birth_date ? '1px solid #f3f5f4' : '1px solid #dc3545',
                   backgroundColor: validate.birth_date ? '#f3f5f4' : 'white'
                 }}></input>

          <input type="text"
                 placeholder="Year"
                 value={birth_year}
                 onChange={ event => {
                  if (event.target.value.length > 4 || parseInt(event.target.value.padEnd(4, '9')) < new Date().getFullYear()-200 || parseInt(event.target.value.padEnd(4, '0')) > new Date().getFullYear())
                    return
                  set_birth_year(event.target.value.replace(/\D/g,''))
                 }}
                 style={{
                   border: validate.birth_year ? '1px solid #f3f5f4' : '1px solid #dc3545',
                   backgroundColor: validate.birth_year ? '#f3f5f4' : 'white'
                 }}></input>
        </div>

        <input type="text"
               placeholder="Email"
               className="text-input"
               value={email}
               onChange={ event => set_email(event.target.value) }
               style={{
                 border: validate.email ? '1px solid #f3f5f4' : '1px solid #dc3545',
                 backgroundColor: validate.email ? '#f3f5f4' : 'white'
               }}></input>

        <div id="select-phone-number">
          <div id="select-country-code">
            <img src={country_codes.get(phone_country_code).src} />
            <i className="arrow-down"></i>
            <select defaultValue="1"
                    onChange={
                      event => {
                        set_phone_country_code(event.target.value)
                        set_phone(`+${event.target.value}`.concat(phone.substring(phone_country_code.length+1)))
                      }
                    }>{
              [...country_codes.keys()].map((code, i) => (
                <option key={i} value={code}>{country_codes.get(code).name} (+{code})</option> 
              )) 
            }</select>
          </div>

          <input type="text"
                 placeholder="Phone Number"
                 className="text-input"
                 value={phone}
                 onChange={ event => {
                  if (!event.target.value.startsWith(`+${phone_country_code}`)) {
                    set_phone(`+${phone_country_code}`)
                    return
                  }

                  const format = event.target.value.substring(phone_country_code.length+1)
                                                   .replace(/\D/g,'')
                                                   .replace(/\D+/g, '')

                  if (format === '') {
                    set_phone(`+${phone_country_code}`)
                    return
                  }
                  if (format.length > 10)
                    return

                  const match = format.replace(/^1/, '')
                                      .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
                  const area_code = match.length > 2 ? `(${match.substring(0,3)})` : match
                  const prefix = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
                  const subscriber = match.length > 6 ? ` ${match.substring(6, 10)}` : ''
                  set_phone(`+${phone_country_code} ${area_code}${prefix}${subscriber}`)
                }}
                style={{
                  border: validate.phone ? '1px solid #f3f5f4' : '1px solid #dc3545',
                  backgroundColor: validate.phone ? '#f3f5f4' : 'white'
                }}></input>
        </div>

        <div className="select-box">
          <button className={ activity==='Medicine' ? 'active-select-option' : 'select-option' } onClick={ () => set_activity(activity==='Medicine' ? '' : 'Medicine') }>Medicine</button>
          <button className={ activity==='Tutoring' ? 'active-select-option' : 'select-option' } onClick={ () => set_activity(activity==='Tutoring' ? '' : 'Tutoring') }>Tutoring</button>
          <button className={ activity==='Other' ? 'active-select-option' : 'select-option' } onClick={ () => set_activity(activity==='Other' ? '' : 'Other') }>Other</button>
        </div>
        { other }

        <button id="submit-form"
                onClick={ () => {
                  let new_validate = {
                    error: '',
                    name: true,
                    gender: true,
                    phone: true,
                    activity: true,
                    other_activity: true,
                    birth_date: true,
                    birth_month: true,
                    birth_year: true,
                    email: true
                  }

                  new_validate.birth_date = !(birth_date > new Date(parseInt(birth_year), parseInt(birth_month), 0).getDate())
                  new_validate.email = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)

                  if (name === '') new_validate.name = false
                  if (phone === '' || phone.substring(phone_country_code.length+1).replace(/\D+/g, '').length < 10) new_validate.phone = false
                  if (birth_date === '') new_validate.birth_date = false
                  if (birth_month === '') new_validate.birth_month = false
                  if (birth_year === '') new_validate.birth_year = false
                  if (email === '') new_validate.email = false
                  if (gender !== 'Male' && gender !== 'Female') new_validate.gender = false
                  if (activity == 'Other' && other_activity === '') new_validate.other_activity = false
                  if (activity !== 'Medicine' && activity !== 'Tutoring' && activity !== 'Other')
                    new_validate.activity = false

                  new_validate.error = gender === '' && activity === '' && new_validate.name &&
                                       new_validate.email && new_validate.phone &&
                                       new_validate.birth_date && new_validate.birth_month &&
                                       new_validate.birth_year
                                     ? 'Select an activity and your gender'
                                     : gender === '' && activity !== '' && new_validate.name &&
                                       new_validate.email && new_validate.phone &&
                                       new_validate.birth_date && new_validate.birth_month &&
                                       new_validate.birth_year
                                     ? 'Select your gender'
                                     : gender !== '' && activity === '' && new_validate.name &&
                                       new_validate.email && new_validate.phone &&
                                       new_validate.birth_date && new_validate.birth_month &&
                                       new_validate.birth_year
                                     ? 'Select an activity'
                                     : ''

                  set_validate(new_validate)

                  if (new_validate.name && new_validate.gender && new_validate.email &&
                      new_validate.phone && new_validate.activity && new_validate.other_activity &&
                      new_validate.birth_date && new_validate.birth_month && new_validate.birth_year) {
                    set_loading(true)

                    const registration_data = {
                      name,
                      gender,
                      email,
                      phone_number: phone,
                      activity: activity==='Other' ? other_activity : activity,
                      birth_date: `${birth_month}/${birth_date}/${birth_year}\n`
                    }

                    emailjs.send(keys.SERVICE_ID, keys.TEMPLATE_ID, registration_data, keys.USER_ID).then(
                      res => {
                        new_validate.error = 'Request Sent!'
                        set_loading(false)
                      },
                      error => {
                        new_validate.error = 'Failed to Send Request'
                        set_loading(false)
                      }
                    )
                  }
                }}>
          Register
        </button>
        { validate_error }
        { loader }
      </div>
    </div>
  )
}